import React from 'react';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';
import Reactor from 'data/reactor';

import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';
import CommonStrings from 'resources/common-strings';
import UserAlert from 'components/page-heading/user-alert';
import RuntimeGetters from 'data/app-runtime/getters';
import UserGetters from 'data/user/getters';
import RuntimeActions from 'data/app-runtime/actions';
import { Immutable } from 'nuclear-js';

export default CreateReactClass({
    displayName: 'family-print-status',
    mixins: [Reactor.ReactMixin],

    PropTypes: {
        nextButtonAction: PropTypes.func.isRequired,
    },

    getDataBindings() {
        return {
            pageAlert: RuntimeGetters.pageAlert,
            reportsHome: UserGetters.reportsHomeLink,
        };
    },

    goToReportsHome() {
        Analytics.recordButtonClick(CommonValues.SectionIDs.printAndShare, 'return-to-reports-home');
        window.location.href = this.state.reportsHome;
    },

    requestAnotherReport(event) {
        Analytics.recordButtonClick(CommonValues.SectionIDs.printAndShare, 'request-another-report');
        RuntimeActions.setPageAlert(
            Immutable.Map({
                messageContent: null,
                isActive: false,
                actionStatus: '',
            })
        );
        this.props.nextButtonAction(event, 'class');
    },

    render() {
        const anotherReportButton =
            this.state.pageAlert.get('actionStatus') == CommonStrings.batchPrint.printStatus.success ? (
                <button className="button-next" onClick={this.requestAnotherReport}>
                    Request Another Report
                </button>
            ) : null;

        return (
            <div className="status options-container">
                <UserAlert pageAlert={this.state.pageAlert} />
                <div className="button-container">
                    <button className="button-next" onClick={this.goToReportsHome}>
                        Return to Reports Home
                    </button>
                    {anotherReportButton}
                </div>
            </div>
        );
    },
});
